import React from "react";

export default function Loader() {
  return (
    <div id="global-loader">
      <img src="assets/img/loader.svg" className="loader-img" alt="Loader" />
    </div>
  );
}
